<template>
    <div
        :class="[
            'flex items-start min-h-[2.75rem] mb-1 rounded',
            type === 'success' && 'bg-alert-green text-white',
            type === 'warning' && 'bg-alert-orange text-white',
            type === 'error' && 'bg-alert-red text-white',
            type === 'info' && 'bg-sky-100 border border-sky-300 text-cyan-950',
        ]"
    >
        <div class="h-12 w-12 lg:w-14 mt-0.5 flex items-center justify-center shrink-0">
            <svg
                v-if="type === 'success'"
                xmlns="http://www.w3.org/2000/svg"
                class="fill-current h-7 lg:h-9"
                viewBox="0 0 40 40"
            ><polygon points="36.44 13.08 32.72 9.36 17.17 24.91 8.88 16.62 5.17 20.34 17.17 32.34 17.17 32.34 17.17 32.34 36.44 13.08" /></svg>

            <svg
                v-else-if="type === 'warning'"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                baseProfile="full"
                class="fill-current w-10 lg:w-12"
                viewBox="-6 -8 90 90"
                xml:space="preserve"
            ><path d="M 58.5832,55.4172L 17.4169,55.4171C 15.5619,53.5621 15.5619,50.5546 17.4168,48.6996L 35.201,15.8402C 37.056,13.9852 40.0635,13.9852 41.9185,15.8402L 58.5832,48.6997C 60.4382,50.5546 60.4382,53.5622 58.5832,55.4172 Z M 34.0417,25.7292L 36.0208,41.9584L 39.9791,41.9583L 41.9583,25.7292L 34.0417,25.7292 Z M 38,44.3333C 36.2511,44.3333 34.8333,45.7511 34.8333,47.5C 34.8333,49.2489 36.2511,50.6667 38,50.6667C 39.7489,50.6667 41.1666,49.2489 41.1666,47.5C 41.1666,45.7511 39.7489,44.3333 38,44.3333 Z" /></svg>

            <svg
                v-else-if="type === 'error'"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                baseProfile="full"
                class="fill-current w-10 lg:w-12"
                viewBox="0 0 75 75"
                xml:space="preserve"
            ><path d="M 38,19C 48.4934,19 57,27.5066 57,38C 57,48.4934 48.4934,57 38,57C 27.5066,57 19,48.4934 19,38C 19,27.5066 27.5066,19 38,19 Z M 34.0417,25.7292L 36.0208,41.9584L 39.9792,41.9583L 41.9583,25.7292L 34.0417,25.7292 Z M 38,44.3333C 36.2511,44.3333 34.8333,45.7511 34.8333,47.5C 34.8333,49.2489 36.2511,50.6667 38,50.6667C 39.7489,50.6667 41.1667,49.2489 41.1667,47.5C 41.1667,45.7511 39.7489,44.3333 38,44.3333 Z " /></svg>

            <Info v-else-if="type === 'info'" />

        </div>
        <span class="py-3 pr-3 [&_a]:underline grow text-lg">
            <slot></slot>
        </span>
    </div>
</template>
<script setup lang="ts">
    import { Info } from '@lucide/vue'

    defineProps<{
        type: 'success'|'error'|'warning'|'info'
    }>()

</script>
